/**
 * Created by hgun0888
 * 12/3/18
 * */

/**
 * Action Types
 */
export const HIDE_ERROR_DIALOG = 'HIDE_ERROR_DIALOG';
export const RECEIVE_ERROR_IN_VENDOR_FILE_IMPORT = 'RECEIVE_ERROR_IN_VENDOR_FILE_IMPORT';
export const RECEIVE_ERROR_IN_VENDOR_ASSOCIATION_FILE_IMPORT = 'RECEIVE_ERROR_IN_VENDOR_ASSOCIATION_FILE_IMPORT';
export const RECEIVE_ERROR_IN_MASS_AGREEMENT_FILE_IMPORT = 'RECEIVE_ERROR_IN_MASS_AGREEMENT_FILE_IMPORT';
export const RECEIVE_ERROR_IN_VENDOR_FILE_PROCESS_STATUS_FETCH = 'RECEIVE_ERROR_IN_VENDOR_FILE_PROCESS_STATUS_FETCH';
export const RECEIVE_ERROR_IN_VENDOR_FILE_LOG_FETCH = 'RECEIVE_ERROR_IN_VENDOR_FILE_LOG_FETCH';
export const RECEIVE_ERROR_IN_832_FILES_FETCH = 'RECEIVE_ERROR_IN_832_FILES_FETCH';
export const RECEIVE_ERROR_IN_FILE_TRANSFER_DETAILS_FETCH = 'RECEIVE_ERROR_IN_FILE_TRANSFER_DETAILS_FETCH';
export const RECEIVE_ERROR_IN_REPORT_DETAILS_FETCH = 'RECEIVE_ERROR_IN_REPORT_DETAILS_FETCH';
export const RECEIVE_ERROR_IN_REPORT_TEMPLATE_CREATION = 'RECEIVE_ERROR_IN_REPORT_TEMPLATE_CREATION';
export const RECEIVE_ERROR_IN_REPORT_TEMPLATE_DELETION = 'RECEIVE_ERROR_IN_REPORT_TEMPLATE_DELETION';
export const RECEIVE_ERROR_IN_AGREEMENT_REPORT_CREATION = 'RECEIVE_ERROR_IN_AGREEMENT_REPORT_CREATION';
export const RECEIVE_ERROR_IN_USER_PROFILE_DETAILS_FETCH = 'RECEIVE_ERROR_IN_USER_PROFILE_DETAILS_FETCH';
export const RECEIVE_ERROR_IN_USER_GROUP_ASSOCIATION_DETAILS_FETCH = 'RECEIVE_ERROR_IN_USER_GROUP_ASSOCIATION_DETAILS_FETCH';
export const RECEIVE_ERROR_IN_USER_PROFILE_DETAILS_FETCH_OF_SELECTED_USER = 'RECEIVE_ERROR_IN_USER_PROFILE_DETAILS_FETCH_OF_SELECTED_USER';
export const RECEIVE_ERROR_IN_USER_GROUP_DETAILS_FETCH = 'RECEIVE_ERROR_IN_USER_GROUP_DETAILS_FETCH';
export const RECEIVE_ERROR_IN_USERS_FETCH = 'RECEIVE_ERROR_IN_USERS_FETCH';
export const RECEIVE_ERROR_IN_ALL_USER_GROUPS_FETCH = 'RECEIVE_ERROR_IN_ALL_USER_GROUPS_FETCH';
export const RECEIVE_ERROR_WHEN_SAVING_USER_MANAGEMENT_DETAILS = 'RECEIVE_ERROR_WHEN_SAVING_USER_MANAGEMENT_DETAILS';
export const RECEIVE_ERROR_IN_SUPPLIER_ONBOARD_DETAILS_FETCH = 'RECEIVE_ERROR_IN_SUPPLIER_ONBOARD_DETAILS_FETCH';
export const RECEIVE_ERROR_IN_USER_ASSOCIATION_AND_BUSINESS_CENTER_CONTACTS_FETCH = 'RECEIVE_ERROR_IN_USER_ASSOCIATION_AND_BUSINESS_CENTER_CONTACTS_FETCH';
export const RECEIVE_ERROR_IN_VENDORS_FETCH = 'RECEIVE_ERROR_IN_VENDORS_FETCH';
export const RECEIVE_ERROR_IN_OPCO_FETCH = 'RECEIVE_ERROR_IN_OPCO_FETCH';
export const RECEIVE_ERROR_IN_REPORT_DATA_FETCH = 'RECEIVE_ERROR_IN_REPORT_DATA_FETCH';
export const RECEIVE_ERROR_IN_BUSINESS_CENTERS_FETCH = 'RECEIVE_ERROR_IN_BUSINESS_CENTERS_FETCH';
export const RECEIVE_ERROR_IN_PRICE_RECORD_TYPES_FETCH = 'RECEIVE_ERROR_IN_PRICE_RECORD_TYPES_FETCH';
export const RECEIVE_ERROR_IN_SUPPLIER_SUPPORT_REQUEST_SUBMISSION = 'RECEIVE_ERROR_IN_SUPPLIER_SUPPORT_REQUEST_SUBMISSION';
export const RECEIVE_ERROR_IN_HELP_TOPIC_CONTENT_FETCH = 'RECEIVE_ERROR_IN_HELP_TOPIC_CONTENT_FETCH';
export const RECEIVE_ERROR_IN_REQUEST_DETAILS_FETCH = 'RECEIVE_ERROR_IN_REQUEST_DETAILS_FETCH';
export const RECEIVE_ERROR_IN_WORKSPACE_REQUEST_SUBMISSION = 'RECEIVE_ERROR_IN_WORKSPACE_REQUEST_SUBMISSION';
export const RECEIVE_ERROR_IN_COST_DATA_FETCH = 'RECEIVE_ERROR_IN_COST_DATA_FETCH';
export const RECEIVE_ERROR_IN_ADHOC_COST_FILE_IMPORT = 'RECEIVE_ERROR_IN_ADHOC_COST_FILE_IMPORT';
export const RECEIVE_ERROR_IN_ITEMS_VALIDATION = 'RECEIVE_ERROR_IN_ITEMS_VALIDATION';
export const CLEAR_ITEMS_VALIDATION_ERROR = 'CLEAR_ITEMS_VALIDATION_ERROR';
export const RECEIVE_ERROR_IN_REQUEST_STATUS_UPDATE = 'RECEIVE_ERROR_IN_REQUEST_STATUS_UPDATE';
export const RECEIVE_ERROR_IN_WORKSPACE_REQUEST_ACTION_CHANGE = 'RECEIVE_ERROR_IN_WORKSPACE_REQUEST_ACTION_CHANGE';
export const RECEIVE_ERROR_IN_WORKSPACE_REQUEST_COMMENT_SUBMISSION = 'RECEIVE_ERROR_IN_WORKSPACE_REQUEST_COMMENT_SUBMISSION';
export const RECEIVE_FILE_LOADING_ERROR = 'RECEIVE_FILE_LOADING_ERROR';
export const RECEIVE_ERROR_IN_ENTERPRISE_COST_MASTER_DATA_FETCH = 'RECEIVE_ERROR_IN_ENTERPRISE_COST_MASTER_DATA_FETCH';
export const RECEIVE_ERROR_IN_ENTERPRISE_COST_DATA_FETCH = 'RECEIVE_ERROR_IN_ENTERPRISE_COST_DATA_FETCH';
export const RECEIVE_ERROR_IN_EARNED_INCOME_MAPPINGS_FETCH = 'RECEIVE_ERROR_IN_EARNED_INCOME_MAPPINGS_FETCH';
export const RECEIVE_ERROR_IN_SAS_FD_DETAILS_FETCH = 'RECEIVE_ERROR_IN_SAS_FD_DETAILS_FETCH';
export const RECEIVE_ERROR_WHEN_SAVING_VENDOR_SAS_DETAILS = 'RECEIVE_ERROR_WHEN_SAVING_VENDOR_SAS_DETAILS';
export const RECEIVE_ERROR_WHEN_ADDING_VENDOR_SAS_DETAILS = 'RECEIVE_ERROR_WHEN_ADDING_VENDOR_SAS_DETAILS';
export const RECEIVE_ERROR_WHEN_SAVING_ITEM_SAS_FD_DETAILS = 'RECEIVE_ERROR_WHEN_SAVING_ITEM_SAS_FD_DETAILS';
export const RECEIVE_ERROR_IN_SAS_FD_FILE_IMPORT = 'RECEIVE_ERROR_IN_SAS_FD_FILE_IMPORT';
export const RECEIVE_ERROR_UPDATE_SUPPLIER_CONTACT = 'ERROR_UPDATE_SUPPLIER_CONTACT';
export const RECEIVE_ERROR_IN_AGREEMENT_NUMBERS = 'RECEIVE_ERROR_IN_AGREEMENT_NUMBERS';
export const RECEIVE_ERROR_IN_AGREEMENT_DETAILS = 'RECEIVE_ERROR_IN_AGREEMENT_DETAILS';
export const RECEIVE_ERROR_IN_AGREEMENT_UPDATE = 'RECEIVE_ERROR_IN_AGREEMENT_UPDATE';
export const RECEIVE_ERROR_IN_AGREEMENT_CREATE = 'RECEIVE_ERROR_IN_AGREEMENT_CREATE';
export const RECEIVE_ERROR_IN_AGREEMENT_CLONE = 'RECEIVE_ERROR_IN_AGREEMENT_CLONE';
export const RECEIVE_ERROR_IN_AGREEMENT_RECALCULATE = 'RECEIVE_ERROR_IN_AGREEMENT_RECALCULATE';
export const RECEIVE_ERROR_IN_AGREEMENT_RECALCULATION_DECLINE = 'RECEIVE_ERROR_IN_AGREEMENT_RECALCULATION_DECLINE';
export const RECEIVE_ERROR_IN_AGREEMENT_DELETE = 'RECEIVE_ERROR_IN_AGREEMENT_DELETE';
export const RECEIVE_ERROR_IN_POST_COMMENT = 'RECEIVE_ERROR_IN_POST_COMMENT';
export const RECEIVE_ERROR_IN_AGREEMENTS_SEARCH_DATA_FETCH = 'RECEIVE_ERROR_IN_AGREEMENTS_SEARCH_DATA_FETCH';
export const RECEIVE_ERROR_IN_MASS_ITEM_UPLOAD_REQUEST = 'RECEIVE_ERROR_IN_MASS_ITEM_UPLOAD_REQUEST';
export const RECEIVE_ERROR_IN_EXCEPTIONS = 'RECEIVE_ERROR_IN_EXCEPTIONS';
export const RECEIVE_EXCEPTIONS_SAVE_ERROR = 'RECEIVE_EXCEPTIONS_SAVE_ERROR';
export const RECEIVE_EXCEPTIONS_DELETE_ERROR = 'RECEIVE_EXCEPTIONS_DELETE_ERROR';
export const RECEIVE_ERROR_IN_EXCEPTION_CODES = 'RECEIVE_ERROR_IN_EXCEPTION_CODES';
export const RECEIVE_ERROR_IN_COST_IMPACT_TERM_FILE_IMPORT = 'RECEIVE_ERROR_IN_COST_IMPACT_TERM_FILE_IMPORT';
export const RECEIVE_ERROR_IN_EI_TERM_DETAILS_FETCH = 'RECEIVE_ERROR_IN_EI_TERM_DETAILS_FETCH';
export const RECEIVE_ERROR_IN_FORMULA_GROUP_REQUEST = 'RECEIVE_ERROR_IN_FORMULA_GROUP_REQUEST';
export const RECEIVE_ERROR_IN_MODULE_PRICE_IMPORT = 'RECEIVE_ERROR_IN_MODULE_PRICE_IMPORT';
export const RECEIVE_ERROR_IN_MODULES_FETCH = 'RECEIVE_ERROR_IN_MODULES_FETCH';
export const RECEIVE_ERROR_IN_MODULE_PRICE_EXPORT = 'RECEIVE_ERROR_IN_MODULE_PRICE_EXPORT';
export const RECEIVE_ERROR_IN_ITEM_PRICE = 'RECEIVE_ERROR_IN_ITEM_PRICE';
export const RECEIVE_ERROR_IN_MODULE_GROUP_CREATE = 'RECEIVE_ERROR_IN_MODULE_GROUP_CREATE';
export const RECEIVE_ERROR_IN_MODULE_GROUP_DELETE = 'RECEIVE_ERROR_IN_MODULE_GROUP_DELETE';
export const RECEIVE_ERROR_IN_COMMODITIES_FETCH = 'RECEIVE_ERROR_IN_COMMODITIES_FETCH';
export const RECEIVE_ERROR_IN_COMMODITY_GROUP_CREATE = 'RECEIVE_ERROR_IN_COMMODITY_GROUP_CREATE';
export const RECEIVE_ERROR_IN_COMMODITY_GROUP_FETCH = 'RECEIVE_ERROR_IN_COMMODITY_GROUP_FETCH';
export const RECEIVE_ERROR_IN_MODULE_GROUPS_ASSOCIATION_FETCH = 'RECEIVE_ERROR_IN_MODULE_GROUP_CREATE';
export const RECEIVE_ERROR_IN_MODULE_GROUP_UPDATE = 'RECEIVE_ERROR_IN_MODULE_GROUP_UPDATE';
export const RECEIVE_ERROR_IN_LOADING_AREAS_FETCH = 'RECEIVE_ERROR_IN_LOADING_AREAS_FETCH';
export const RECEIVE_ERROR_IN_MODULE_GROUP_LOADING_AREA_ASSIGNMENT = 'RECEIVE_ERROR_IN_MODULE_GROUP_LOADING_AREA_ASSIGNMENT';
export const RECEIVE_ERROR_IN_MODULE_GROUP_COMMODITY_ASSIGNMENT = 'RECEIVE_ERROR_IN_MODULE_GROUP_COMMODITY_ASSIGNMENT';
export const RECEIVE_ERROR_IN_COMMODITY_GROUP_DELETE = 'RECEIVE_ERROR_IN_COMMODITY_GROUP_DELETE';
export const RECEIVE_ERROR_IN_COMMODITY_GROUP_UPDATE = 'RECEIVE_ERROR_IN_COMMODITY_GROUP_UPDATE';
export const RECEIVE_ERROR_IN_COMMODITY_GROUP_ITEM_ASSIGNMENT = 'RECEIVE_ERROR_IN_COMMODITY_GROUP_ITEM_ASSIGNMENT';
export const RECEIVE_ERROR_IN_PRICE_MODULE_ITEMS_FETCH = 'RECEIVE_ERROR_IN_PRICE_MODULE_ITEMS_FETCH';
export const RECEIVE_ERROR_IN_LOADING_AREA_DETAILS_FETCH = 'RECEIVE_ERROR_IN_LOADING_AREA_DETAILS_FETCH';
export const RECEIVE_ERROR_IN_LOADING_AREA_CREATE = 'RECEIVE_ERROR_IN_LOADING_AREA_CREATE';
export const RECEIVE_ERROR_IN_LOADING_AREA_DELETE = 'RECEIVE_ERROR_IN_LOADING_AREA_DELETE';
export const RECEIVE_ERROR_IN_LOADING_AREA_UPDATE = 'RECEIVE_ERROR_IN_LOADING_AREA_UPDATE';
export const RECEIVE_ERROR_IN_MODULE_GROUP_REACTIVATE = 'RECEIVE_ERROR_IN_MODULE_GROUP_REACTIVATE';
export const RECEIVE_ERROR_IN_COMMODITY_GROUP_REACTIVATE = 'RECEIVE_ERROR_IN_COMMODITY_GROUP_REACTIVATE';
export const RECEIVE_ERROR_IN_LOADING_AREA_REACTIVATE = 'RECEIVE_ERROR_IN_LOADING_AREA_REACTIVATE';
export const RECEIVE_ERROR_IN_MODULE_PRICES_UPDATE = 'RECEIVE_ERROR_IN_MODULE_PRICES_UPDATE';
export const RECEIVE_ERROR_IN_COST_VIEW_DATA_FETCH = 'RECEIVE_ERROR_IN_COST_VIEW_DATA_FETCH';
export const RECEIVE_ERROR_IN_COST_VIEW_DETAILED_DATA_FETCH = 'RECEIVE_ERROR_IN_COST_VIEW_DETAILED_DATA_FETCH';
export const RECEIVE_ERROR_IN_SEGMENT_DETAILS_CODES_FETCH = 'RECEIVE_ERROR_IN_SEGMENT_DETAILS_CODES_FETCH';
export const RECEIVE_ERROR_IN_SEGMENT_DETAILS_FETCH = 'RECEIVE_ERROR_IN_SEGMENT_DETAILS_FETCH';
export const RECEIVE_ERROR_IN_SEGMENT_DETAILS_CREATION = 'RECEIVE_ERROR_IN_SEGMENT_DETAILS_CREATION';
export const RECEIVE_ERROR_IN_SEGMENT_DETAILS_UPDATE = 'RECEIVE_ERROR_IN_SEGMENT_DETAILS_UPDATE';
export const RECEIVE_ERROR_IN_SEGMENT_DETAILS_DELETION = 'RECEIVE_ERROR_IN_SEGMENT_DETAILS_DELETION';
export const RECEIVE_ERROR_IN_SEGMENT_DETAILS_FETCH_DELETED = 'RECEIVE_ERROR_IN_SEGMENT_DETAILS_FETCH_DELETED';

/**
 * Actions
 */
export const hideErrorDialog = () => ({ type: HIDE_ERROR_DIALOG });
export const receiveErrorInMassItemUploadRequest = (data) => (
  { type: RECEIVE_ERROR_IN_MASS_ITEM_UPLOAD_REQUEST, data });
export const receiveErrorInFormulaGroupRequest = (data) => (
  { type: RECEIVE_ERROR_IN_FORMULA_GROUP_REQUEST, data });
export const receiveErrorInVendorFileImport = (data) => (
  { type: RECEIVE_ERROR_IN_VENDOR_FILE_IMPORT, data });
export const receiveErrorInVendorAssociationFileImport = (data) => (
  { type: RECEIVE_ERROR_IN_VENDOR_ASSOCIATION_FILE_IMPORT, data });
export const receiveErrorInMassAgreementFileImport = (data) => (
  { type: RECEIVE_ERROR_IN_MASS_AGREEMENT_FILE_IMPORT, data });
export const receiveErrorInVendorFileProcessStatusFetch = () => (
  { type: RECEIVE_ERROR_IN_VENDOR_FILE_PROCESS_STATUS_FETCH });
export const receiveErrorInVendorFileLogFetch = (data) => (
  { type: RECEIVE_ERROR_IN_VENDOR_FILE_LOG_FETCH, data });
export const receiveErrorInFileTransferDetailsFetch = (data) => (
  { type: RECEIVE_ERROR_IN_FILE_TRANSFER_DETAILS_FETCH, data });
export const receiveErrorIn832FilesFetch = (data) => (
  { type: RECEIVE_ERROR_IN_832_FILES_FETCH, data });
export const receiveErrorInReportDetailsFetch = (data) => (
  { type: RECEIVE_ERROR_IN_REPORT_DETAILS_FETCH, data });
export const receiveErrorInUserProfileDetailsFetch = (data) => (
  { type: RECEIVE_ERROR_IN_USER_PROFILE_DETAILS_FETCH, data });
export const receiveErrorInUserGroupAssociationDetailsFetch = (data) => (
  { type: RECEIVE_ERROR_IN_USER_GROUP_ASSOCIATION_DETAILS_FETCH, data });
export const receiveErrorInUserProfileDetailsFetchOfSelectedUser = (data) => (
  { type: RECEIVE_ERROR_IN_USER_PROFILE_DETAILS_FETCH_OF_SELECTED_USER, data });
export const receiveErrorInUserGroupDetailsFetch = (data) => (
  { type: RECEIVE_ERROR_IN_USER_GROUP_DETAILS_FETCH, data });
export const receiveErrorInUsersFetch = (data) => (
  { type: RECEIVE_ERROR_IN_USERS_FETCH, data });
export const receiveErrorInAllUserGroupsFetch = (data) => (
  { type: RECEIVE_ERROR_IN_ALL_USER_GROUPS_FETCH, data });
export const receiveErrorWhenSavingUserManagementDetails = (data) => (
  { type: RECEIVE_ERROR_WHEN_SAVING_USER_MANAGEMENT_DETAILS, data });
export const receiveErrorInSupplierOnboardDetailsFetch = (data) => (
  { type: RECEIVE_ERROR_IN_SUPPLIER_ONBOARD_DETAILS_FETCH, data });
export const receiveErrorInUserAssociationAndBusinessCenterContactsFetch = (data) => (
  { type: RECEIVE_ERROR_IN_USER_ASSOCIATION_AND_BUSINESS_CENTER_CONTACTS_FETCH, data });
export const receiveErrorInVendorsFetch = (data) => (
  { type: RECEIVE_ERROR_IN_VENDORS_FETCH, data });
export const receiveErrorInOpcoFetch = (data) => (
  { type: RECEIVE_ERROR_IN_OPCO_FETCH, data });
export const receiveErrorInReportTemplateCreation = (data) => (
  { type: RECEIVE_ERROR_IN_REPORT_TEMPLATE_CREATION, data });
export const receiveErrorInReportTemplateDeletion = (data) => (
  { type: RECEIVE_ERROR_IN_REPORT_TEMPLATE_DELETION, data });
export const receiveErrorInAgreementReportCreation = (data) => (
  { type: RECEIVE_ERROR_IN_AGREEMENT_REPORT_CREATION, data });
export const receiveErrorInBusinessCentersFetch = (data) => (
  { type: RECEIVE_ERROR_IN_BUSINESS_CENTERS_FETCH, data });
export const receiveErrorInPriceRecordTypesFetch = (data) => (
  { type: RECEIVE_ERROR_IN_PRICE_RECORD_TYPES_FETCH, data });
export const receiveErrorInSupplierSupportRequestSubmission = (data) => (
  { type: RECEIVE_ERROR_IN_SUPPLIER_SUPPORT_REQUEST_SUBMISSION, data });
export const receiveErrorInHelpTopicContentFetch = (data) => (
  { type: RECEIVE_ERROR_IN_HELP_TOPIC_CONTENT_FETCH, data });
export const receiveErrorInRequestDetailsFetch = (data) => (
  { type: RECEIVE_ERROR_IN_REQUEST_DETAILS_FETCH, data });
export const receiveErrorInWorkspaceRequestSubmission = (data) => (
  { type: RECEIVE_ERROR_IN_WORKSPACE_REQUEST_SUBMISSION, data });
export const receiveErrorInCostDataFetch = (data) => (
  { type: RECEIVE_ERROR_IN_COST_DATA_FETCH, data });
export const receiveErrorInAdhocCostFileImport = (data) => (
  { type: RECEIVE_ERROR_IN_ADHOC_COST_FILE_IMPORT, data });
export const receiveErrorItemsValidation = (data) => (
  { type: RECEIVE_ERROR_IN_ITEMS_VALIDATION, data });
export const clearItemsValidationError = () => ({ type: CLEAR_ITEMS_VALIDATION_ERROR });
export const receiveErrorInRequestStatusUpdate = (data) => (
  { type: RECEIVE_ERROR_IN_REQUEST_STATUS_UPDATE, data });
export const receiveErrorInWorkspaceRequestActionChange = (data) => (
  { type: RECEIVE_ERROR_IN_WORKSPACE_REQUEST_ACTION_CHANGE, data });
export const receiveErrorInWorkspaceRequestCommentSubmission = (data) => (
  { type: RECEIVE_ERROR_IN_WORKSPACE_REQUEST_COMMENT_SUBMISSION, data });
export const receiveFileLoadingError = (data) => (
  { type: RECEIVE_FILE_LOADING_ERROR, data });
export const receiveErrorInEnterpriseCostMasterDataFetch = (data) => (
  { type: RECEIVE_ERROR_IN_ENTERPRISE_COST_MASTER_DATA_FETCH, data });
export const receiveErrorInEnterpriseCostDataFetch = (data) => (
  { type: RECEIVE_ERROR_IN_ENTERPRISE_COST_DATA_FETCH, data });
export const receiveErrorInEarnedIncomeMappingsFetch = (data) => (
  { type: RECEIVE_ERROR_IN_EARNED_INCOME_MAPPINGS_FETCH, data });
export const receiveErrorInSASFDDetailsFetch = (data) => (
  { type: RECEIVE_ERROR_IN_SAS_FD_DETAILS_FETCH, data });
export const receiveErrorWhenSavingVendorSASDetails = (data) => (
  { type: RECEIVE_ERROR_WHEN_SAVING_VENDOR_SAS_DETAILS, data });
export const receiveErrorInSASFDFileImport = (data) => (
  { type: RECEIVE_ERROR_IN_SAS_FD_FILE_IMPORT, data });
export const receiveErrorWhenAddingVendorSASDetails = (data) => (
  { type: RECEIVE_ERROR_WHEN_ADDING_VENDOR_SAS_DETAILS, data });
export const receiveErrorWhenSavingItemSasFdDetails = (data) => (
  { type: RECEIVE_ERROR_WHEN_SAVING_ITEM_SAS_FD_DETAILS, data });
export const receiveErrorUpdateSupplierContact = (data) => (
  { type: RECEIVE_ERROR_UPDATE_SUPPLIER_CONTACT, data });
export const receiveErrorInAgreementNumbers = (data) => (
  { type: RECEIVE_ERROR_IN_AGREEMENT_NUMBERS, data });
export const receiveErrorInAgreementDetails = (data) => (
  { type: RECEIVE_ERROR_IN_AGREEMENT_DETAILS, data });
export const receiveErrorInAgreementUpdate = (data) => (
  { type: RECEIVE_ERROR_IN_AGREEMENT_UPDATE, data });
export const receiveErrorInAgreementCreate = (data) => (
  { type: RECEIVE_ERROR_IN_AGREEMENT_CREATE, data });
export const receiveErrorInAgreementClone = (data) => (
  { type: RECEIVE_ERROR_IN_AGREEMENT_CLONE, data });
export const receiveErrorInAgreementRecalculate = (data) => (
  { type: RECEIVE_ERROR_IN_AGREEMENT_RECALCULATE, data });
export const receiveErrorInAgreementRecalculationDecline = (data) => (
  { type: RECEIVE_ERROR_IN_AGREEMENT_RECALCULATION_DECLINE, data });
export const receiveErrorInAgreementDelete = (data) => (
  { type: RECEIVE_ERROR_IN_AGREEMENT_DELETE, data });
export const receiveErrorInPostingComment = (data) => (
  { type: RECEIVE_ERROR_IN_POST_COMMENT, data });
export const receiveErrorInAgreementsSearchDataFetch = (data) => (
  { type: RECEIVE_ERROR_IN_AGREEMENTS_SEARCH_DATA_FETCH, data });
export const receiveErrorInExceptions = (data) => (
  { type: RECEIVE_ERROR_IN_EXCEPTIONS, data });
export const receiveExceptionsSaveError = (data) => (
  { type: RECEIVE_EXCEPTIONS_SAVE_ERROR, data });
export const receiveExceptionsDeleteError = (data) => (
  { type: RECEIVE_EXCEPTIONS_DELETE_ERROR, data });
export const receiveErrorInExceptionCodes = (data) => (
  { type: RECEIVE_ERROR_IN_EXCEPTION_CODES, data });
export const receiveErrorInEarnedIncomeTermFileImport = (data) => (
  { type: RECEIVE_ERROR_IN_COST_IMPACT_TERM_FILE_IMPORT, data });
export const receiveErrorInEiTermDetailsFetch = (data) => (
  { type: RECEIVE_ERROR_IN_EI_TERM_DETAILS_FETCH, data });
export const receiveErrorInModulePriceImport = (data) => (
  { type: RECEIVE_ERROR_IN_MODULE_PRICE_IMPORT, data });
export const receiveErrorInModulesFetch = (data) => (
  { type: RECEIVE_ERROR_IN_MODULES_FETCH, data });
export const receiveErrorInModulePriceExport = (data) => (
  { type: RECEIVE_ERROR_IN_MODULE_PRICE_EXPORT, data });
export const receiveErrorInItemPrice = (data) => (
  { type: RECEIVE_ERROR_IN_ITEM_PRICE, data });
export const receiveErrorInModuleGroupCreate = (data) => (
  { type: RECEIVE_ERROR_IN_MODULE_GROUP_CREATE, data });
export const receiveErrorInModulesAssociationsFetch = (data) => (
  { type: RECEIVE_ERROR_IN_MODULE_GROUPS_ASSOCIATION_FETCH, data });
export const receiveErrorInCommoditiesFetch = (data) => (
  { type: RECEIVE_ERROR_IN_COMMODITIES_FETCH, data });
export const receiveErrorInCommodityGroupCreate = (data) => (
  { type: RECEIVE_ERROR_IN_COMMODITY_GROUP_CREATE, data });
export const receiveErrorInCommodityDetailsFetch = (data) => (
  { type: RECEIVE_ERROR_IN_COMMODITY_GROUP_FETCH, data });
export const receiveErrorInModuleGroupDelete = (data) => (
  { type: RECEIVE_ERROR_IN_MODULE_GROUP_DELETE, data });
export const receiveErrorInModuleGroupUpdate = (data) => (
  { type: RECEIVE_ERROR_IN_MODULE_GROUP_UPDATE, data });
export const receiveErrorInModuleGroupLoadingAreaAssignment = (data) => (
  { type: RECEIVE_ERROR_IN_MODULE_GROUP_LOADING_AREA_ASSIGNMENT, data });
export const receiveErrorInModuleGroupCommodityAssignment = (data) => (
  { type: RECEIVE_ERROR_IN_MODULE_GROUP_COMMODITY_ASSIGNMENT, data });
export const receiveErrorInLoadingAreasFetch = (data) => (
  { type: RECEIVE_ERROR_IN_LOADING_AREAS_FETCH, data });
export const receiveErrorInCommodityGroupDelete = (data) => (
  { type: RECEIVE_ERROR_IN_COMMODITY_GROUP_DELETE, data });
export const receiveErrorInCommodityGroupUpdate = (data) => (
  { type: RECEIVE_ERROR_IN_COMMODITY_GROUP_UPDATE, data });
export const receiveErrorInCommodityGroupItemAssignment = (data) => (
  { type: RECEIVE_ERROR_IN_COMMODITY_GROUP_ITEM_ASSIGNMENT, data });
export const receiveErrorInPriceModuleItemsFetch = (data) => (
  { type: RECEIVE_ERROR_IN_PRICE_MODULE_ITEMS_FETCH, data });
export const receiveErrorInLoadingAreaUpdate = (data) => (
  { type: RECEIVE_ERROR_IN_LOADING_AREA_UPDATE, data });
export const receiveErrorInLoadingAreaCreate = (data) => (
  { type: RECEIVE_ERROR_IN_LOADING_AREA_CREATE, data });
export const receiveErrorInLoadingAreaDetailsFetch = (data) => (
  { type: RECEIVE_ERROR_IN_LOADING_AREA_DETAILS_FETCH, data });
export const receiveErrorInLoadingAreaDelete = (data) => (
  { type: RECEIVE_ERROR_IN_LOADING_AREA_DELETE, data });
export const receiveErrorInModuleGroupReactivate = (data) => (
  { type: RECEIVE_ERROR_IN_MODULE_GROUP_REACTIVATE, data });
export const receiveErrorInCommodityGroupReactivate = (data) => (
  { type: RECEIVE_ERROR_IN_COMMODITY_GROUP_REACTIVATE, data });
export const receiveErrorInLoadingAreaReactivate = (data) => (
  { type: RECEIVE_ERROR_IN_LOADING_AREA_REACTIVATE, data });
export const receiveErrorInModulePricesUpdate = (data) => (
  { type: RECEIVE_ERROR_IN_MODULE_PRICES_UPDATE, data });
export const receiveErrorInCostViewDataFetch = (data) => (
  { type: RECEIVE_ERROR_IN_COST_VIEW_DATA_FETCH, data });
export const receiveErrorInCostViewDetailedDataFetch = (data) => (
  { type: RECEIVE_ERROR_IN_COST_VIEW_DETAILED_DATA_FETCH, data });
export const receiveErrorInSegmentCodesFetch = (data) => (
  { type: RECEIVE_ERROR_IN_SEGMENT_DETAILS_CODES_FETCH, data });
export const receiveErrorSegmentDetailsFetch = (data) => (
  { type: RECEIVE_ERROR_IN_SEGMENT_DETAILS_FETCH, data });
export const receiveErrorInSegmentDetailsCreation = (data) => (
  { type: RECEIVE_ERROR_IN_SEGMENT_DETAILS_CREATION, data });
export const receiveErrorInSegmentDetailsUpdate = (data) => (
  { type: RECEIVE_ERROR_IN_SEGMENT_DETAILS_UPDATE, data });
export const receiveErrorInSegmentDetailsDeletion = (data) => (
  { type: RECEIVE_ERROR_IN_SEGMENT_DETAILS_DELETION, data });
export const receiveErrorInSegmentDetailsFetchDeleted = (data) => (
  { type: RECEIVE_ERROR_IN_SEGMENT_DETAILS_FETCH_DELETED, data });
